<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      show-save-button
      unit="校讯通设置"
      edit-title
      id-key="EduToHomeId"
      form-label-width="140px"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="启用学校" prop="SchoolId">
              <el-select size="mini" v-model="data.SchoolId" style="width:100%;">
                <el-option
                  v-for="(i,key) in schools"
                  :key="key"
                  :label="i.SchoolName"
                  :value="i.SchoolId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="月收费" prop="MonthCharge">
              <el-input size="mini" v-model="data.MonthCharge" v-num placeholder="请填写月收费"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始计费月份" prop="StartMonth">
              <el-date-picker
                v-model="data.StartMonth"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择时间"
                style="width:100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="截止计费月份" prop="EndMonth">
              <el-date-picker
                v-model="data.EndMonth"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择时间"
                style="width:100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始充值月份" prop="RechargeMonth">
              <el-date-picker
                v-model="data.RechargeMonth"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择时间"
                style="width:100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="一次性收费">
              <span>{{data.TotalMonth}}个月、{{data.TotalCharge}}元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="每月通话次数上限" prop="MonthCountLimit">
              <el-input size="mini" v-model="data.MonthCountLimit" v-int>
                <span slot="append">次</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="每次通话时长上限" prop="SingleDurationLimit">
              <el-input size="mini" v-model="data.SingleDurationLimit" v-int>
                <span slot="append">分钟</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="收费规则及服务内容" prop="Remark">
              <el-input type="textarea" placeholder="请输入" v-model="data.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        EduToHomeId: 0,
        SchoolId: null,
        MonthCharge: null,
        StartMonth: "",
        StartMonthDate: null, //开始计费月份1号日期
        EndMonth: "",
        EndMonthDate: null, //截止计费月份最后一天日期
        RechargeMonth: "",
        RechargeMonthDate: null, //开始充值月份1号日期
        TotalMonth: null,
        TotalCharge: null,
        MonthCountLimit: null,
        SingleDurationLimit: null,
        Status: 1, // 0:停用 1:启用
        Remark: "",
      },
      schools: [],
      api: require("@/api/consume/edutohome").default,
      school_api: require("@/api/st/school").default,
      isMB: this.$store.state.isMB,
      rules: {
        SchoolId: [{ required: true, message: "请选择启用学校" }],
        MonthCharge: [{ required: true, message: "月收费不能为空" }],
        StartMonth: [{ required: true, message: "请选择开始计费月份" }],
        EndMonth: [{ required: true, message: "请选择截止计费月份" }],
        RechargeMonth: [{ required: true, message: "请选择开始充值月份" }],
        StartMonth: [{ required: true, message: "请选择开始计费月份" }],
        MonthCountLimit: [
          { required: true, message: "每月通话次数上限不能为空" },
        ],
        SingleDurationLimit: [
          { required: true, message: "每次通话时长上限不能为空" },
        ],
        Status: [{ required: true, message: "请选择状态" }],
      },
    };
  },
  watch: {
    "data.StartMonth": {
      handler(val, oval) {
        if (val) {
          var date = this.$dayjs(val + "-01");
          var value = date.startOf("month").format("YYYY-MM-DD");
          if (this.data.EndMonthDate) {
            var edate = this.$dayjs(this.data.EndMonthDate).startOf("month").$d;
            if (new Date(value) > edate) {
              this.$message.warning("截止计费月份必须大于开始计费月份");
              this.data.StartMonth = oval;
              return;
            }
            var svalue = date.startOf("month");
            var evalue = this.$dayjs(this.data.EndMonthDate).endOf("month");
            var diff = svalue.diff(evalue, "month", true);
            this.data.TotalMonth = Math.abs(diff).toFixed(0);
            if (this.data.MonthCharge) {
              var total = this.data.TotalMonth * this.data.MonthCharge;
              this.data.TotalCharge = total;
            }
          }
          this.data.StartMonthDate = value;
          this.data.RechargeMonth = date.subtract(1, "month").format("YYYY-MM");
        } else {
          this.data.StartMonthDate = null;
          this.data.TotalMonth = null;
          this.data.TotalCharge = null;
        }
      },
    },
    "data.EndMonth": {
      handler(val, oval) {
        if (val) {
          var date = this.$dayjs(val + "-01");
          var value = date.endOf("month").format("YYYY-MM-DD");
          if (this.data.StartMonthDate) {
            var edate = date.startOf("month").$d;
            if (edate < new Date(this.data.StartMonthDate)) {
              this.$message.warning("截止计费月份必须大于开始计费月份");
              this.data.EndMonth = oval;
              return;
            }
            var svalue = this.$dayjs(this.data.StartMonthDate).startOf("month");
            var evalue = date.endOf("month");
            var diff = svalue.diff(evalue, "month", true);
            this.data.TotalMonth = Math.abs(diff).toFixed(0);
            if (this.data.MonthCharge) {
              var total = this.data.TotalMonth * this.data.MonthCharge;
              this.data.TotalCharge = total;
            }
          }
          if (this.data.RechargeMonthDate) {
            var edate = date.startOf("month").$d;
            if (edate < new Date(this.data.RechargeMonthDate)) {
              var rdate = date.subtract(1, "month").format("YYYY-MM");
              this.data.RechargeMonth = rdate;
            }
          }
          this.data.EndMonthDate = value;
        } else {
          this.data.EndMonthDate = null;
          this.data.TotalMonth = null;
          this.data.TotalCharge = null;
        }
      },
    },
    "data.RechargeMonth": {
      handler(val, oval) {
        if (val) {
          var date = this.$dayjs(val + "-01");
          var value = date.startOf("month").format("YYYY-MM-DD");

          if (this.data.EndMonthDate) {
            var edate = this.$dayjs(this.data.EndMonthDate).startOf("month").$d;
            if (new Date(value) > edate) {
              this.$message.warning("开始充值月份必须小于截止计费月份");
              this.data.RechargeMonth = oval;
              return;
            }
          }

          if (this.data.StartMonthDate) {
            var sdate = this.$dayjs(this.data.StartMonthDate);
            var smonth = sdate.subtract(2, "month").$d;
            if (new Date(value) < smonth) {
              this.$message.warning("开始充值月份最多提前两个月");
              this.data.RechargeMonth = oval;
              return;
            }
          }

          this.data.RechargeMonthDate = value;
        } else {
          this.data.RechargeMonthDate = null;
        }
      },
    },
    "data.MonthCharge": {
      handler(val, oval) {
        if (val) {
          if (this.data.StartMonthDate && this.data.EndMonthDate) {
            var svalue = this.$dayjs(this.data.StartMonthDate).startOf("month");
            var evalue = this.$dayjs(this.data.EndMonthDate).endOf("month");
            var diff = svalue.diff(evalue, "month", true);
            this.data.TotalMonth = Math.abs(diff).toFixed(0);
            this.data.TotalCharge = this.data.TotalMonth * val;
          }
        } else {
          this.data.TotalCharge = null;
        }
      },
    },
  },
  computed: {},
  methods: {
    onOpened() {
      this.school_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.schools = res.Data;
      });
    },
    onEditOpened(data) {
      // console.log("data", data);
      // console.log("this.data", this.data);
      this.data.RechargeMonth = data.RechargeMonth;
    },
    onBeforeSave() {
      var svalue = this.$dayjs(this.data.StartMonthDate).startOf("month");
      var evalue = this.$dayjs(this.data.EndMonthDate).endOf("month");
      var diff = svalue.diff(evalue, "month", true);

      if (Math.abs(diff).toFixed(0) > 12) {
        this.$message.warning("月份合计不能大于12个月");
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss">
</style>